/*
 * Licensed Materials - Property of IBM
 *
 * PID 5725-H26
 *
 * Copyright IBM Corporation 2018. All Rights Reserved.
 *
 * US Government Users Restricted Rights - Use, duplication or disclosure
 * restricted by GSA ADP Schedule Contract with IBM Corp.
 */
/*
 * System Configurations utility / service.
 */
import ReduxUtils from '../../utils/ReduxUtils';
import SystemProperty from './models';

/**
 * Calls the /system_configurations API. If successful that api will return a json
 * object that can be converted to a {@link SystemProperty}. Otherwise an error will occur
 * and the user will be notified accordingly.
 * @param {function} callback
 */
var fetchSystemProperties = function fetchSystemProperties(callback) {
  ReduxUtils.getParsedDataFromRestAPI(callback, 'v1/ua/system_configurations', SystemProperty);
};
export default {
  fetchSystemProperties: fetchSystemProperties
};